<template>
  <v-container class="container--max">
    <slot name="ad-leaderboard">
      <ad-leaderboard></ad-leaderboard>
    </slot>
    <v-row justify="center" class="my-4">
      <!-- left -->
      <v-col cols="12" sm="11" md="11" lg="11">
        <slot name="main"></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AppPageFullWidth',

  }
</script>
